import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const getCabinDetails = createAsyncThunk(
  "getCabinDetails",
  async (values) => {
    const { booking_id, room_id } = values;
    var requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        payload: {
          booking_id: booking_id,
          room_id: room_id,
        },
        action_type: "GETALLCABINS",
      }),
    };

    return await fetch(
      `${process.env.REACT_APP_BASE_URL_PHP}controller/actionsController.php`,
      requestOptions
    )
      .then((response) => {
        return response.json();
      })
      .catch((error) => console.log("error", error));
  }
);

const allCabinDetailsSlice = createSlice({
  name: "allCabinDetails",
  initialState: {
    isLoading: false,
    cabin_details: [],
  },
  extraReducers: (builder) => {
    builder.addCase(getCabinDetails.pending, (state, action) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(getCabinDetails.fulfilled, (state, action) => {
      state.cabin_details = action.payload.guest_upgraded_price_details;
      state.isLoading = false;
    });
    builder.addCase(getCabinDetails.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default allCabinDetailsSlice.reducer;
